import React from 'react';
import * as firebase from 'firebase';
import {
  BrowserRouter as Router,
  useLocation,
  useHistory
} from "react-router-dom";
import { NavBarGuest, NavBarAffiliate, NavBarUser } from '../view/NavBar';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import '../view/css/AffiliateGallery.css'
import { AffiliateGalleryView } from '../view/AffiliateGalleryView';

export function AffiliateGallery(props) {

  const [initialLoad, setInitialLoad] = React.useState(false);
  const [type_1, setType] = React.useState("");
  const [photos, setPhotos] = React.useState([]);
  const [photosSet, setPhotosSet] = React.useState(false);
  const [images, setImages] = React.useState([]);

  let history = useHistory();
  
  var firestore = firebase.firestore();
  var user = firebase.auth().currentUser;
  const location = useLocation();

  const runThis = () => {

    if (user) {
       const db = firestore.collection("Users").doc(user.email);
       const doc = db.get().then(function (doc) {
          if (doc.exists) {
              setType(doc.data().type)
          }
       }).catch(function (error) {
           console.log("Error getting document:", error);
       });
    }

    const db = firestore.collection("Users").doc(location.state.id);
    const doc = db.get().then(function (doc) {
      if (doc.exists) {
        setPhotos(doc.data().photos);
        setInitialLoad(true);
      }
    });
  }

  const populatePhotos = () => {
    photos.forEach((photo) => (
      images.push(
        {
          original: photo,
          thumbnail: photo,
        }
      )
    ))
    setPhotosSet(true);
    console.log("I am in populatePhotos");
  }

  const checkPhotos = () => {
    console.log(images);
    console.log(photos);
  }

  return (
    <AffiliateGalleryView history={history.goBack} type_1={type_1} initialLoad={initialLoad} runThis={runThis} photosSet={photosSet} populatePhotos={populatePhotos} images={images} />
  );
}